<div class="du-bottom-popup-content">
  <span class="du-bottom-popup-expension" (click)="toggleExpand()">
    <span *ngIf="!isExpanded" style="cursor: pointer !important;">
        <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H32L27.1567 14.5298C26.0678 17.7966 23.0107 20 19.5673 20H12.4327C8.9893 20 5.93219 17.7966 4.84327 14.5298L0 0Z" fill="#1363DF"/>
            <path d="M19.3346 9.33333L16.0013 6L12.668 9.33333" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.3346 14.0013L16.0013 10.668L12.668 14.0013" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </span>
    <span *ngIf="isExpanded" style="cursor: pointer !important;">
        <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0H32L27.1567 14.5298C26.0678 17.7966 23.0107 20 19.5673 20H12.4327C8.9893 20 5.93219 17.7966 4.84327 14.5298L0 0Z" fill="#1363DF"/>
            <path d="M12.668 6L16.0013 9.33333L19.3346 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.668 10.668L16.0013 14.0013L19.3346 10.668" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </span>
  </span>

   <div *ngIf="widgetConfig">
       <ng-container [app-widget]="{ item: widgetConfig, pageKey: pageKey, selectedHeader: selectedHeader}"></ng-container>
    </div>
</div>
